import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Dialog,
  DialogActions,
} from '@mui/material';
import PdfViewer from '../pdfViewer/PdfViewer';

type Props = {
  isOpen: boolean;
  fileUrl: string;
  onClose: () => void;
  onAccept?: () => void;
}

const TermsConfirmationDialog: React.FC<Props> = ({
  isOpen, onClose, onAccept, fileUrl,
}: Props) => {
  const [loaded, setLoaded] = useState(false);
  const [isError, setIsError] = useState(false);

  return (
    <Dialog maxWidth="lg" fullWidth open={isOpen}>
      <PdfViewer pdfUrl={fileUrl} onLoadSuccess={setLoaded} onError={setIsError} />
      {
        loaded && (
          <DialogActions>
            <Button
              color="secondary"
              variant="contained"
              onClick={onClose}
            >
              <FormattedMessage id="genericClose" />
            </Button>
            {
              onAccept && (
                <Button
                  color="primary"
                  variant="contained"
                  onClick={onAccept}
                >
                  <FormattedMessage id="confirm" />
                </Button>

              )
            }
          </DialogActions>
        )
      }
      {
        isError && (
          <DialogActions>
            <Button
              color="secondary"
              variant="contained"
              onClick={onClose}
            >
              <FormattedMessage id="genericClose" />
            </Button>
          </DialogActions>
        )
      }
    </Dialog>
  );
};

export default TermsConfirmationDialog;
